module.exports = __webpack_public_path__ + "static/media/gif_Tipeee_step_4.a1a909ba.gif";